<div class="p-component pb-3 border-bottom-2 border-primary">
    <h1 class="page-title m-0">Sync Status</h1>
</div>

<app-unsync-transactions-list context="Global"></app-unsync-transactions-list>